import helper from "./helper";
// import user from "../store/modules/user";

let getSurveyUrl = helper.getSurveyUrlWithParameters

export default {
    getSurveyUrl,
    getByRecievedUrlData:
      /**
       * Получает URL на основе полученных данных
       * @param {Object} url - Объект с данными URL
       * @param {Object} gets - Query-параметры
       * @returns {string} Сформированный URL
       */
      (url, gets = null) => getSurveyUrl(
        url.basename,
        url.action,
        url.params,
        gets
    ),
    CHOICES_SELECTOR: {
        FIELD_TYPE:
          /**
           * Получает URL для получения типов полей опроса
           * @param {Object} gets - Query-параметры
           * @returns {string} URL для получения списка типов полей
           */
            (gets = null) => getSurveyUrl(
                'surveys|choices|field_type_choices',
                "get",
                gets
            ),
        DOCUMENT_TYPE:
          /**
           * Получает URL для получения типов документов
           * @param {number} survey_id - Идентификатор опроса
           * @param {Object} gets - Query-параметры
           * @returns {string} URL для получения списка типов документов
           */
            (survey_id, gets = null) => getSurveyUrl(
                'surveys|choices|content_type_choices',
                "get",
                gets
            ),
        KIND_TYPE:
          /**
           * Получает URL для получения типов видов опросов
           * @param {Object} gets - Query-параметры
           * @returns {string} URL для получения списка типов видов
           */
            (gets = null) => getSurveyUrl(
                'surveys|choices|kind_type_choices',
                "get",
                gets
            ),
        ANONYMITY_TYPE:
          /**
           * Получает URL для получения типов анонимности
           * @param {Object} gets - Query-параметры
           * @returns {string} URL для получения списка типов анонимности
           */
            (gets = null) => getSurveyUrl(
                'surveys|choices|anonymity_type_choices',
                "get",
                gets
            ),
        DATE_DYNAMIC_TYPE:
          /**
           * Получает URL для получения типов динамических дат
           * @param {Object} gets - Query-параметры
           * @returns {string} URL для получения списка типов динамических дат
           */
            (gets = null) => getSurveyUrl(
                'surveys|choices|date_dynamic_value_type_choices',
                "get",
                gets
            ),
        COHERENT_TYPE:
          /**
           * Получает URL для получения типов последовательностей
           * @param {Object} gets - Query-параметры
           * @returns {string} URL для получения списка типов последовательностей
           */
            (gets = null) => getSurveyUrl(
                'surveys|choices|coherent_type_choices',
                "get",
                gets
            ),
    },

}
